import { Division, Paragraph } from "@ir/ui";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { PageContent } from "@src/presentation/components/Layout/common";
import { UsersAccessFooter, UsersAccessHeader, UsersDataTable } from "./utils";
import { useUsersAccessData } from "@src/presentation/providers/UsersAccessDataProvider";
import { LoadingSpinner } from "@src/presentation/components/common";

export const PAGE_LIMIT = 15;

const UsersAccessContent = () => {
  const { loading, error } = useUsersAccessData();

  let content = null;
  if (loading) {
    content = <LoadingSpinner />;
  } else if (error) {
    content = <Paragraph className="text-danger m-0">{error}</Paragraph>;
  } else {
    content = <UsersDataTable />;
  }

  return (
    <ErrorBoundary>
      <PageContent
        className="p-4"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <Division
          style={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {content}
        </Division>
      </PageContent>
    </ErrorBoundary>
  );
};

export const UsersAccess = () => (
  <ErrorBoundary>
    <UsersAccessHeader />
    <UsersAccessContent />
    <UsersAccessFooter />
  </ErrorBoundary>
);
